export default __webpack_public_path__ + "static/media/bg-valdano-mentor@3x.933dee8d.jpg";